const INDEX_ITEMS = [
  { label: '娱乐圈', icon: 'ri-movie-line', count: '12,850', color: 'bg-primary-100 text-primary-700' },
  { label: '网红圈', icon: 'ri-live-line', count: '9,432', color: 'bg-accent-100 text-accent-700' },
  { label: '社会热点', icon: 'ri-fire-line', count: '7,680', color: 'bg-secondary-100 text-secondary-900' },
  { label: '独家爆料', icon: 'ri-spy-line', count: '5,921', color: 'bg-primary-100 text-primary-700' },
  { label: '综艺内幕', icon: 'ri-tv-2-line', count: '8,314', color: 'bg-accent-100 text-accent-700' },
  { label: '明星八卦', icon: 'ri-star-line', count: '15,203', color: 'bg-secondary-100 text-secondary-900' },
  { label: '影视揭秘', icon: 'ri-film-line', count: '6,447', color: 'bg-primary-100 text-primary-700' },
  { label: '音乐圈', icon: 'ri-music-line', count: '4,892', color: 'bg-accent-100 text-accent-700' },
  { label: '体育圈', icon: 'ri-basketball-line', count: '3,765', color: 'bg-secondary-100 text-secondary-900' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">专题合集</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">按主题分类浏览黑料视频，快速找到你感兴趣的专题内容</p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#"
              className="flex flex-col items-center gap-2 p-4 md:p-5 bg-background-100 border border-background-200/70 rounded-xl hover:border-primary-200 hover:bg-background-50 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${item.color} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-500">{item.count} 条</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}